import { animate, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fgb-mobile-banner',
  templateUrl: './mobile-banner.component.html',
  styleUrl: './mobile-banner.component.scss',

  animations: [
    trigger('fadeAnimation', [transition('* => *', [style({ opacity: 0 }), animate('600ms ease-out', style({ opacity: 1 }))])]),
  ],
})
export class MobileBannerComponent implements OnInit {
  imgSrc: string;
  images: string[] = [
    'assets/images/banners/mobile/game-banner-1.jpg',
    'assets/images/banners/mobile/game-banner-2.jpg',
    'assets/images/banners/mobile/game-banner-3.jpg',
    'assets/images/banners/mobile/game-banner-4.jpg',
    'assets/images/banners/mobile/game-banner-5.jpg',
    'assets/images/banners/mobile/game-banner-6.jpg',
    'assets/images/banners/mobile/game-banner-7.jpg',
    'assets/images/banners/mobile/game-banner-8.jpg',
    'assets/images/banners/mobile/game-banner-9.jpg',
    'assets/images/banners/mobile/game-banner-10.jpg',
    'assets/images/banners/mobile/game-banner-11.jpg',
    'assets/images/banners/mobile/game-banner-12.jpg',
  ];

  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.imgSrc = this.getRandomImage(this.images);
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const filteredImages = this.images.filter((img: string) => img !== this.imgSrc);
        this.imgSrc = this.getRandomImage(filteredImages);
      }
    });
  }

  getRandomImage(arr: string[]): string {
    return arr[Math.floor(Math.random() * arr.length)];
  }
}
